import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Radar, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";

const BG = "https://images.pexels.com/photos/14493179/pexels-photo-14493179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1300&w=1600";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.2fr_1fr]">
      <div className="relative hidden lg:block overflow-hidden">
        <img src={BG} alt="Luchtfoto woonwijk" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#090D16]/60" />
        <div className="absolute inset-0 grid-bg" />
        <div className="absolute bottom-12 left-12 right-12 fade-up">
          <div className="font-mono text-xs tracking-widest text-sky-300 mb-3">BAG · KADASTRALE KAART · PDOK LUCHTFOTO</div>
          <h1 className="text-5xl font-extrabold tracking-tight max-w-xl leading-[1.05]">Zie elke nieuwe aanbouw, schuur en tuinhuis — per perceel, per jaar.</h1>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="login-form">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-md bg-blue-600 grid place-items-center"><Radar className="h-5 w-5" /></div>
            <div>
              <div className="font-display text-2xl font-bold tracking-tight">GeoInspect</div>
              <div className="font-mono text-[10px] tracking-widest text-slate-500">OMGEVINGSDIENST PORTAAL</div>
            </div>
          </div>
          <div className="space-y-3">
            <label className="block text-xs text-slate-400">E-mailadres
              <Input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-slate-950 border-slate-800 h-11" />
            </label>
            <label className="block text-xs text-slate-400">Wachtwoord
              <Input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-slate-950 border-slate-800 h-11" />
            </label>
          </div>
          {error && <div data-testid="login-error" className="text-sm text-rose-400 border border-rose-500/30 bg-rose-500/10 rounded-md px-3 py-2">{error}</div>}
          <button data-testid="login-form-submit-button" disabled={busy} className="w-full h-11 rounded-md bg-blue-600 hover:bg-blue-500 transition-colors font-medium flex items-center justify-center gap-2 disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Inloggen
          </button>
        </form>
      </div>
    </div>
  );
}
